import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { M_FLOW_HEX, E_FLOW_HEX, L_FLOW_HEX } from '../../../constants';
const TARGET_FLOWS = {
    id: 'target_material_flows',
    type: 'target',
    name: 'Сырьё',
    position: Position.Left,
    style: { top: 206, left: 8, background: M_FLOW_HEX },
    connectionCount: Number.MAX_SAFE_INTEGER
};
const SOURCE_INTERMEDIATE_FLOWS = {
    id: 'source_material_intermediate_selections_flows',
    type: 'source',
    name: 'Потоки бокового отбора',
    position: Position.Right,
    style: { top: 207, right: 8, background: M_FLOW_HEX },
    connectionCount: Number.MAX_SAFE_INTEGER
};
const SOURCE_REBOILER_FLOW = {
    id: 'source_material_reboiler_flow',
    type: 'source',
    name: 'Кубовой остаток',
    position: Position.Right,
    style: { top: 323, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_CAPACITOR_LIQUID_FLOW = {
    id: 'source_material_capacitor_liquid_flow',
    type: 'source',
    name: 'Жидкий поток конденсатора',
    position: Position.Right,
    style: { top: 133, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_CAPACITOR_GAS_FLOW = {
    id: 'source_material_capacitor_gas_flow',
    type: 'source',
    name: 'Выходной энергетический поток конденсатора',
    position: Position.Right,
    style: { top: 27, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const TARGET_ENERGY_REBOILER_FLOW = {
    id: 'target_energy',
    type: 'target',
    name: 'Входной энергетический поток ребойлера',
    position: Position.Bottom,
    style: { bottom: 27, left: 131, background: E_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_ENERGY_CAPACITOR_FLOW = {
    id: 'source_energy_capacitor_flow',
    type: 'source',
    name: 'Выходной энергетический поток конденсатора',
    position: Position.Top,
    style: { top: 8, left: 122, background: E_FLOW_HEX },
    connectionCount: 1
};
const TARGET_LOGICAL = {
    id: 'target_logical_flow',
    type: 'target',
    name: 'Входные параметры',
    position: Position.Left,
    style: { top: 369, left: 9, background: L_FLOW_HEX },
    connectionCount: Number.MAX_SAFE_INTEGER
};
const SOURCE_LOGICAL = {
    id: 'source_logical_flow',
    type: 'source',
    name: 'Выходные параметры',
    position: Position.Right,
    style: { top: 369, right: 8, background: L_FLOW_HEX },
    connectionCount: Number.MAX_SAFE_INTEGER
};
export const DISTILLATION_COLUMN_RC_CONFIG = {
    type: ERFElement.DistillationColumnRC,
    icon: 'DistillationColumnRC_2d',
    templates: [
        {
            code: 'universal-template-partial_capacitor',
            ports: [
                TARGET_FLOWS,
                SOURCE_INTERMEDIATE_FLOWS,
                SOURCE_REBOILER_FLOW,
                SOURCE_CAPACITOR_LIQUID_FLOW,
                SOURCE_CAPACITOR_GAS_FLOW,
                TARGET_ENERGY_REBOILER_FLOW,
                SOURCE_ENERGY_CAPACITOR_FLOW,
                /* PORTS FOR LOGICAL ELEMENTS */
                TARGET_LOGICAL,
                SOURCE_LOGICAL
            ]
        },
        {
            code: 'universal-template-complete_capacitor',
            ports: [
                TARGET_FLOWS,
                SOURCE_INTERMEDIATE_FLOWS,
                SOURCE_REBOILER_FLOW,
                SOURCE_CAPACITOR_LIQUID_FLOW,
                TARGET_ENERGY_REBOILER_FLOW,
                SOURCE_ENERGY_CAPACITOR_FLOW,
                /* PORTS FOR LOGICAL ELEMENTS */
                TARGET_LOGICAL,
                SOURCE_LOGICAL
            ]
        },
        {
            code: 'universal-template-complete_reflux_capacitor',
            ports: [
                TARGET_FLOWS,
                SOURCE_INTERMEDIATE_FLOWS,
                SOURCE_REBOILER_FLOW,
                SOURCE_CAPACITOR_GAS_FLOW,
                TARGET_ENERGY_REBOILER_FLOW,
                SOURCE_ENERGY_CAPACITOR_FLOW,
                /* PORTS FOR LOGICAL ELEMENTS */
                TARGET_LOGICAL,
                SOURCE_LOGICAL
            ]
        }
    ]
};
//# sourceMappingURL=RFDistillationColumnRCNode.config.js.map